<div class="x_panel">
  <ng-content select="ap-panel-title"></ng-content>
  <ng-content select="ap-panel-subtitle"></ng-content>
  <ng-content select="ap-panel-content"></ng-content>
</div>
